import DatePicker, { registerLocale } from "react-datepicker";
import { es } from "date-fns/locale/es";
import { BsCalendarCheck } from "react-icons/bs";

registerLocale("es", es);

export const DatePickerForm = ({
  label,
  sublabel,
  placeholder,
  validation,
  submit,
  name,
  value,
  onChange,
  disabled,
}) => {
  return (
    <div>
      <label className="form-label mb-0">
        {label} <span className="text-gray-300 fs-sm">{sublabel}</span>
      </label>
      <div className="datepicker-wrapper">
        <DatePicker
          selected={value}
          onChange={onChange}
          locale="es"
          className={`form-control pe-5 ${validation && submit && "border-danger"}`}
          dateFormat="dd/MM/yyyy"
          placeholderText={placeholder}
          todayButton="Hoy"
          minDate={new Date()}
          formatWeekDay={(nameOfDay) =>
            nameOfDay.slice(0, 1).toUpperCase() +
            nameOfDay.slice(1, 3).toLowerCase()
          }
          disabled={disabled}
        />
        <BsCalendarCheck className="datepicker-icon" />
      </div>
      {validation && submit && (
        <span className="text-danger">{validation}</span>
      )}
    </div>
  );
};